import { atom, useSetAtom } from 'jotai';
import { useEffect, useMemo } from 'react';
import { isCampaignActive } from 'src/components/SponsoredListings/SponsoredListings.util';
import { SponsoredListingsCampaign } from 'src/WebApiController';

export const boostedEventIdsAtom = atom<Set<number>>(new Set([]));

export const useBoostedEventIdsFromCampaigns = (
  allCampaignData?: Record<number, SponsoredListingsCampaign[]> | null
) => {
  const setBoostedEventIds = useSetAtom(boostedEventIdsAtom);

  const boostedEventIds = useMemo(() => {
    if (!allCampaignData) return null;
    const ids = new Set<number>();
    for (const [eventId, campaigns] of Object.entries(allCampaignData)) {
      if (campaigns.some(isCampaignActive)) {
        ids.add(Number(eventId));
      }
    }
    return ids;
  }, [allCampaignData]);

  useEffect(() => {
    if (boostedEventIds) {
      setBoostedEventIds(boostedEventIds);
    }
  }, [boostedEventIds, setBoostedEventIds]);
};
